<template>
  <fragment>
    <hero-header page-name="Xiaomi" hero-title="mobilfutar"/>
    <v-container class="my-5">
      <v-row justify="center" align-content="center">
        <v-img :src="`${publicPath}images/xiaomi/D2D-Xiaomi-banner.jpg`" width="100%" max-width="959"></v-img>
      </v-row>
    </v-container>
    <v-container class="my-5" id="sRep">
      <v-row class="my-5">
        <v-col cols="12" md="12">
          <div v-html="$t('xiaomiRepairText')"></div>
        </v-col>
        <!--v-col cols="12" md="3">
          <v-card>
            <div class="mx-auto" style="max-width: 220px;">
              <v-img :src="require(`../assets/brand_logos/xiaomi.png`)" title="Xiaomi" alt="Xiaomi"/>
            </div>
          </v-card>
          <div class="text-center subtitle-2">
            Xiaomi
          </div>
        </v-col-->
      </v-row>
      <v-row justify="center">
        <template v-for="(item, index) in repairBoxes">
          <v-col cols="12" sm="4" md="3" :key="index">
            <service-box v-bind:service="item" :show-desc="false" :show-button="true"/>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import serviceBox from '../components/serviceBox.vue';

export default {
  name: 'MobilfutarXiaomiPage',
  components: {
    heroHeader, serviceBox,
  },
  props: {
    //
  },
  data() {
    return {
      repairBoxes: [
        {
          id: 's8920472',
          img: 'garancialis-javitas',
          title: 'repairBoxes.warrantyRepair',
          desc: 'repairBoxes.warrantyRepairDesc',
          button: {
            path: 'mobilfutarjav-xiaomi',
            text: 'button.next',
            local: true,
          },
        },
        {
          id: 's329j5653',
          img: 'fizetos-javitas',
          title: 'repairBoxes.payedRepair',
          desc: 'repairBoxes.payedRepairDesc',
          button: {
            path: 'https://www.mostmobil.hu/szerviz-kalkulator',
            text: 'button.next',
            local: false,
            external: true,
          },
        },
      ],
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
